module.exports = __webpack_public_path__ + "img/hair_back_female_frizzy_medium_mask.e35a149f.png";